// Import Swiper core and required modules
import Swiper from 'swiper';
import { Mousewheel, Navigation, Pagination, Keyboard } from 'swiper/modules'; // Mousewheel, Navigation, Pagination, Keyboard module

import "swiper/css"; // Core Swiper styles
import "swiper/css/pagination"; // Pagination styles
import "swiper/css/navigation"; // Add Navigation styles

// Extend global window object to store Swiper
declare global {
  interface Window {
    Swiper: typeof Swiper;
    Mousewheel: typeof Mousewheel; // Add Mousewheel to global interface
    Navigation: typeof Navigation; // Add Navigation to global interface
    Pagination: typeof Pagination; // Add Pagination to global interface
    Keyboard: typeof Keyboard; // Add Keyboard to global interface
  }
}

window.Swiper = Swiper;
window.Mousewheel = Mousewheel; // Make Mousewheel available globally
window.Navigation = Navigation; // Make Navigation available globally
window.Keyboard = Keyboard; // Make Navigation available globally
